import { useState } from "react";
import BannerSlide from "src/components/@ai-liberman/quantitative-agent/banner-slide";
import libermanLogo from "src/assets/ai-liberman/ai-lieberman-logo.png"
import ResearchObjectives from "src/components/@ai-liberman/quantitative-agent/research-objectives";
import SampleProfile from "src/components/@ai-liberman/quantitative-agent/sample-profile";
import DogOwnership from "src/components/@ai-liberman/quantitative-agent/dog-ownership";
import PurchasingBehavior from "src/components/@ai-liberman/quantitative-agent/purchasing-behaviour";
import InnovationTrial from "src/components/@ai-liberman/quantitative-agent/innovation-trial";
import SubscriptionAwareness from "src/components/@ai-liberman/quantitative-agent/subscription-awareness";
import ThankYouSlide from "src/components/@ai-liberman/qualitative-agent/thankyou-slide";
import SubscriptionUsageContinued from "src/components/@ai-liberman/quantitative-agent/susbcription-usage-continued";
import SubscriptionReasonSatisfaction from "src/components/@ai-liberman/quantitative-agent/susbcription-reason-satisfaction";
import SocialMediaInfluence from "src/components/@ai-liberman/quantitative-agent/social-media-influence";
import SpendingBehavior from "src/components/@ai-liberman/quantitative-agent/spending-behaviour";
import DriverSpendingShift from "src/components/@ai-liberman/quantitative-agent/driver-spending-shift";
import Recommendations from "src/components/@ai-liberman/quantitative-agent/recommendations";

const pptResponse = {
  "research_objectives":[
    "Market expansion impact",
    "Subscription influence",
    "Social media effect",
    "Spending dynamics",
    "Segmentation differences",
  ],
  "methodology_details": {
      "interview_style": "60-minute qualitative interviews",
      "sample_size": 10,
      "participant_segments": ["Patients", "Caregivers", "Oncology HCPs"],
      "analysis_methods": ["Thematic coding", "Emotional mapping", "Cross-segment synthesis"]
    },
}
// 1️⃣ Define your slides array (outside the component)
const slides = [
  BannerSlide,
   ()=> <ResearchObjectives researchObject={pptResponse?.research_objectives ?? []} methadology={pptResponse?.methodology_details ?? []}/>,
  SampleProfile,
  DogOwnership,
  PurchasingBehavior,
  InnovationTrial,
  SubscriptionAwareness,
  SubscriptionUsageContinued,
  SubscriptionReasonSatisfaction,
  SocialMediaInfluence,
  SpendingBehavior,
  DriverSpendingShift,
  Recommendations,
  ThankYouSlide
];

export default function QuantitativeAgent() {
  // 2️⃣ Use slides.length and slides[index] safely
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState<"next" | "prev">("next");

  const goNext = () => {
    setDirection("next");
    setIndex((i) => Math.min(i + 1, slides.length - 1));
  };

  const goPrev = () => {
    setDirection("prev");
    setIndex((i) => Math.max(i - 1, 0));
  };

  const SlideComponent = slides[index];

  return (
    <div className="w-full mx-auto bg-white p-3 flex flex-col">
        <div className="border-2 border-[#8CC54F] flex flex-col flex-auto py-3 px-5 relative shadow-md">
            <div className="absolute top-0 left-0 inline-flex z-10">
                <span className="w-[20px] h-[14px] bg-[#92D050]"></span>
                <span className="w-[60px] h-[14px] bg-[#8CC54F]"></span>
            </div>
            <div
                key={index}
                className={`relative transition-all duration-500 h-full ease-in-out ${
                direction === "next"
                    ? "animate-slideInFromRight"
                    : "animate-slideInFromLeft"
                }`}
            >
                <SlideComponent />
            </div>

            <img src={libermanLogo} className="absolute left-0 bottom-0 p-1 bg-white z-10" width={100} height={14} />

            <div className="inline-flex items-center justify-center absolute bottom-0 right-0 bg-[#8CC54F] text-white px-1 py-[5px] z-10">
                <span className="text-xs font-medium tracking-wide">
                {index + 1} / {slides.length}
                </span>
            </div>

      </div>

      <div className="mt-2 flex items-center justify-between gap-4">
        <button
          onClick={goPrev}
          disabled={index === 0}
          className="px-2 py-[12px] rounded-md border border-[#8CC54F] text-sm font-medium 
                     text-[#8CC54F] bg-white  disabled:opacity-40 
                     disabled:cursor-not-allowed"
        >
          Previous
        </button>

        

        <button
          onClick={goNext}
          disabled={index === slides.length - 1}
          className="px-2 py-[12px] rounded-md bg-[#8CC54F] text-white text-sm font-medium 
                      disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Next
        </button>
      </div>

      
    </div>
  );
}
